<template>
  <BaseModal
    name="addBalanceSecondStepModal"
    width="890"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="beforeClose"
    @before-open="loadData"
    :adaptive="true"
    height="795"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('addBalanceSecondStepModal')"
      ></button>

      <div>
        <div class="tw-app-modal__title">{{ dataLang["reg_company_50"] }}</div>

        <div class="tw-app-modal__title tw-text-forText">
          {{ dataLang["reg_company_49"] }}
        </div>

        <div
          class="overflow-auto wp-100 tw-mt-[15px]"
          style="min-height: 550px; max-height: 551px"
        >
          <ve-table
            class="rest-style-table"
            style="width: 100%"
            :columns="columns"
            :table-data="dataTable"
            :border-x="true"
            :border-y="true"
            row-key-field-name="payId"
            ref="mainTable"
            :eventCustomOption="eventCustomOption"
            v-if="!localLoading"
            :cell-style-option="cellStyleOption"
            :checkbox-option="{
              selectedRowChange: selectedRowChange,
              selectedAllChange: selectedAllChange,
              hideSelectAll: false,
            }"
            :clickHighlight="false"
            :rowStyleOption="{
              hoverHighlight: true,
            }"
            :cellSelectionOption="{ enable: false }"
          >
          </ve-table>
        </div>

        <div class="tw-app-modal__footer">
          <button
            @click="$modal.hide('addBalanceSecondStepModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["reg_company_23"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["reg_company_24"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";

export default {
  components: {
    VeTable,
  },

  props: {},
  data() {
    return {
      link: "",
      localLoading: false,
      activeSelectRowsMultiple: [],
      dataForEmit: {},
      pincode: "1234",
      currentId: null,
      fileUrl: "",
      computedTransData: "",
      dataTable: [],
      counterString: "",
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {};
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {},
      },
    };
  },
  methods: {
    beforeClose() {
      this.computedTransData = "";
      this.dataTable = [];
      this.counterString = "";
      this.activeSelectRowsMultiple = [];
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    calculateTranslate() {
      let counterAmount = 0;
      // this.activeSelectRowsMultiple.forEach((el, idx) => {
      //   let findedData = this.dataTable.find((val) => val.payId == el)
      //   if (findedData) {
      //     counterAmount = +findedData.amount
      //   }
      // })
      // setTimeout(() => {
      //   this.$nextTick(() => {
      //   this.counterString = this.computedTranslate(
      //     {
      //       number: this.activeSelectRowsMultiple.length,
      //       total: counterAmount
      //     },
      //     this.dataLang['reg_company_51']
      //   )
      // })
      // }, 1000);
      // this.activeSelectRowsMultiple.forEach((el, idx) => {
      //   let findedData = this.dataTable.find((val) => val.payId == el)
      //   if (findedData) {
      //     counterAmount = +findedData.amount
      //   }
      // })
      // this.counterString = counterAmount
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
      this.calculateTranslate();
    },
    loadData({ params }) {
      this.pincode = params?.pincode;
      this.localLoading = true;
      this.link = params?.link;
      this.dataTable = params?.dataTable;
      this.localLoading = false;
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values?.[keyName]
        );
      });
      return tranaslateLocal;
    },
    async loadFile(e) {
      this.localLoading = true;
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", "bank_document_xlsx");

      try {
        let dataFrom = await GeneralService.editOrCreate("/storage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.fileUrl = dataFrom.data.data.url;
        this.localLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
    beforeClose(event) {
      this.dataForEmit = {};
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
      //   this.$refs[data.name].classList.remove('input-error')
    },
    sendData() {
      if (this.activeSelectRowsMultiple.length) {
        this.localLoading = true;
        GeneralService.editOrCreate(
          `/super/companies/balance/in/step3?pincode=${this.pincode}`,
          {
            link: this.link,
            paymentIds: this.activeSelectRowsMultiple,
          }
        )
          .then((gege) => {
            console.log(gege);
            this.$toast.success(gege.data.message);
            this.$modal.hide("addBalanceSecondStepModal");
            this.$modal.show("doneModal", {
              types: true,
              awdawdwadawd: "wfewefefw",
            });
          })
          .catch((e) => {
            console.error(e);
            this.$modal.hide("addBalanceSecondStepModal");
            this.$toast.error(e.response.data.message, { duration: 5000 });
          })
          .finally(() => {
            this.localLoading = false;
          });
      }
    },
  },
  mounted() {
    this.counterString = this.computedTranslate(
      {
        number: 0,
        total: 0,
      },
      this.dataLang["reg_company_51"]
    );
  },
  created() {},
  beforeDestroy() {},
  updated() {
    // console.log(1231233)
    // this.calculateTranslate()
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),

    columns() {
      return [
        {
          field: "",
          key: "a62",
          type: "checkbox",
          title: "",
          width: "1%",
          align: "center",
        },
        {
          field: "companyName",
          key: "1623236",
          title: this.dataLang["reg_company_33"],
          align: "center",
          width: "24%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companyId",
          key: "162336",
          title: this.dataLang["reg_company_52"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companyInn",
          key: "16336",
          title: this.dataLang["reg_company_16"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "amount",
          key: "136326",
          title: this.dataLang["reg_company_53"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companyBalanceBefore",
          key: "162136",
          title: this.dataLang["reg_company_32"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },

          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.companyBalanceBefore
                  ? String(row.companyBalanceBefore).split(".").join(",")
                  : ""}
              </span>
            );
          },
        },
        {
          field: "companyBalanceAfter",
          key: "172551",
          title: this.dataLang["reg_company_37"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },

          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.companyBalanceAfter
                  ? String(row.companyBalanceAfter).split(".").join(",")
                  : ""}
              </span>
            );
          },
        },
      ];
    },
  },
};
</script>
